//import { apiRequest } from "./ActionUtils"

export function changeInputValue(name, value) {
  return function(dispatch) {
    dispatch({
      type: 'DIALOGPHOTOPREVIEW_CHANGE_INPUT_VALUE',
      payload: {name, value}
    });
  }
}